import { Component, ComponentChild } from 'preact'
import { PureComponent } from 'preact-compat'

type OnChange = (newValue: string) => void
type OnEnter = () => void

const handleEnter = (e: KeyboardEvent, onEnter: OnEnter | undefined) => {
  if (e.key === 'Enter' && onEnter) {
    e.preventDefault()
    e.stopPropagation()
    onEnter()
  }
}

const handleChange = (e: KeyboardEvent, onChange: OnChange) => {
  if (e.target instanceof HTMLInputElement && onChange) {
    onChange(e.target.value)
  }
}

interface Props {
  attributes: {
    type?: string
    placeholder?: string
    value?: string
  }
  initialValue?: string
  className?: string
  preIcon?: ComponentChild
  postIcon?: ComponentChild
  onEnter?: OnEnter
  onChange: OnChange
  onFocus?: () => void
  onBlur?: () => void
  disabled?: boolean
}

class InputGroup extends PureComponent<Props> {
  render() {
    const { preIcon, postIcon } = this.props
    return (
      <div className='form-group'>
        <div className='input-wrapper'>
          {Boolean(preIcon) && <span className='pre-icon-wrapper input-icon-wrapper'>{preIcon}</span>}
          <Input {...this.props} />
          {Boolean(postIcon) && <span className='post-icon-wrapper input-icon-wrapper'>{postIcon}</span>}
        </div>
      </div>
    )
  }
}

class Input extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return (
      this.props.attributes.value !== nextProps.attributes.value ||
      this.props.attributes.placeholder !== nextProps.attributes.placeholder ||
      this.props.postIcon !== nextProps.postIcon ||
      this.props.onChange !== nextProps.onChange ||
      this.props.onEnter !== nextProps.onEnter ||
      this.props.className !== nextProps.className
    )
  }

  render() {
    const { className, postIcon, onEnter, onFocus, onBlur, onChange, initialValue, disabled } = this.props
    return (
      <input
        className={`input-group ${className} ${postIcon ? 'has-post-icon' : ''}`}
        onKeyUp={(e: KeyboardEvent) => {
          return handleChange(e, (value) => {
            onChange(value)
          })
        }}
        onKeyDown={(e: KeyboardEvent) => handleEnter(e, onEnter)}
        onFocus={onFocus}
        onBlur={onBlur}
        value={initialValue}
        disabled={disabled}
        {...this.props.attributes}
      />
    )
  }
}

export default InputGroup
